import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import * as Sentry from "@sentry/angular";
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
export const tokenInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);
  const messageService = inject(MessageService);
  const token = localStorage.getItem('token');
  if (!token) {
    localStorage.removeItem('user');
    router.navigateByUrl('/auth/login');
    return next(req);
  }
  const isCloudinary = req.url.startsWith('https://api.cloudinary.com/');
  if (isCloudinary) {
    const noAuthReq = req.clone({ headers: req.headers.delete('Authorization') });
    return next(noAuthReq);
  }
  req = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });
  return next(req);
};
export function errorInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const router = inject(Router);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      Sentry.captureException(error);
      if (error.error.error === 'Unauthorized') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        router.navigateByUrl('/auth/login');
      }
      console.error('Erreur de la requête:', error);
      return throwError(error);
    })
  );
}
